import _ from 'lodash';

import * as actionTypes from './actionTypes';
import getAxiosInstance, {BASE_URL_TYPE} from '../../api/axios';

const axios = getAxiosInstance();

const saveUserSavedTemplates = (name = null, templates = null, callback = null, payload = {}) => {
  const {
    actionType, urlPrefix, statePath, dataKey, omittedProps = [],
  } = payload;
  return (dispatch, getState) => {
    const state = getState();
    let data = {};
    if (!_.isNull(templates)) {
      data = {
        multiple: true,
        data: templates,
      };
    }
    const stateValue = _.omit(_.get(state, statePath), omittedProps);
    if (!stateValue.place) {
      const {breadcrumbs} = state.ui;
      const placeData = breadcrumbs.find(item => item.type === 'place');
      if (placeData) {
        stateValue.place = {
          type: 'autocomplete',
          paramName: 'place',
          value: {[placeData.placeId]: placeData.text},
        };
      }
    }
    if (name && !_.isEmpty(stateValue)) {
      data = {
        data: {
          name,
          [dataKey]: stateValue,
        },
      };
    }
    if (!_.isEmpty(data)) {
      const currentUid = _.get(state, 'user.userData.current_uid');
      if (currentUid) {
        const saveTemplatesUrl = `${urlPrefix + currentUid}/save`;
        dispatch({
          type: actionTypes.SET_LOADING,
          state: true,
        });
        axios
          .post(saveTemplatesUrl, data)
          .then((result) => {
            dispatch({
              type: actionType,
              data: result.data,
            });
            dispatch({
              type: actionTypes.SET_LOADING,
              state: false,
            });
            if (callback) {
              callback();
            }
          })
          .catch((e) => {
            console.error(e);
            dispatch({
              type: actionTypes.SET_LOADING,
              state: false,
            });
          });
      }
    }
  };
};

export const addLayer = layer => ({
  type: actionTypes.ADD_LAYER,
  layer,
});

export const removeLayer = layer => ({
  type: actionTypes.REMOVE_LAYER,
  layer,
});

export const resetLayers = (updateParam = 1) => ({
  type: actionTypes.RESET_LAYERS,
  updateParam,
});

export const setLayersData = data => ({
  type: actionTypes.STORE_ALL_LAYERS,
  data,
});

export const switchLayers = (layers, updateParam = 1, shouldBeParsed = false) => ({
  type: actionTypes.SWITCH_LAYERS,
  layers,
  updateParam,
  shouldBeParsed,
});

export const layersUpdateStart = () => ({
  type: actionTypes.LAYERS_UPDATE_START,
});

export const layersUpdateDone = () => ({
  type: actionTypes.LAYERS_UPDATE_DONE,
});

export const switchLayersLegend = state => ({
  type: actionTypes.SWITCH_LAYERS_LEGEND,
  state,
});
export const setLayersJurisdictions = (data, updateParam = 1) => ({
  type: actionTypes.SET_LAYERS_JURISDICTIONS,
  data,
  updateParam,
});

export const controlCheckedLayers = (enable = {}, disable = {}) => ({
  type: actionTypes.CONTROL_CHECKED_LAYERS,
  enable,
  disable,
});

export const fetchMapData = (url, callback = null) => (dispatch) => {
  axios(url, {withCredentials: true})
    .then((data) => {
      dispatch({
        type: actionTypes.FETCH_MAP_DATA,
        data: data.data,
      });
      if (callback) {
        callback();
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

export const setMapData = mapData => ({
  type: actionTypes.FETCH_MAP_DATA,
  data: mapData,
});

export const setGridInitialized = data => ({
  type: actionTypes.SET_GRID_INITIALIZED,
  data,
});

export const setPlaceBoundary = data => ({
  type: actionTypes.SET_PLACE_BOUNDARY,
  data,
});

export const setPropertyPopupData = propertyPopupData => ({
  type: actionTypes.SET_PROPERTY_POPUP_DATA,
  propertyPopupData,
});

export const setMapGeometry = mapGeometry => ({
  type: actionTypes.SET_MAP_GEOMETRY,
  mapGeometry,
});

export const setMap3dMode = (mode3d, updateParam = 1) => ({
  type: actionTypes.SET_MODE_3D,
  mode3d,
  updateParam,
});

export const resetBuildings = () => ({
  type: actionTypes.RESET_BUILDINGS,
});

export const saveUserSavedLayerTemplates = (name = null, templates = null, callback = null) => {
  const payload = {
    urlPrefix: `${BASE_URL_TYPE.PROPZONE}/saved-layers-templates/`,
    actionType: actionTypes.FETCH_USER_SAVED_LAYER_TEMPLATES,
    statePath: 'map.layers.checkedLayers',
    dataKey: 'layers',
  };
  return saveUserSavedTemplates(name, templates, callback, payload);
};

export const setCurrentLayerTemplate = name => ({
  type: actionTypes.CURRENT_LAYER_TEMPLATE,
  name,
});

export const setUserSavedLayerTemplates = data => ({
  type: actionTypes.FETCH_USER_SAVED_LAYER_TEMPLATES,
  data,
});

export const setCurrentBuildingsTemplate = name => ({
  type: actionTypes.CURRENT_BUILDINGS_TEMPLATE,
  name,
});

export const setUserSavedBuildingsTemplates = data => ({
  type: actionTypes.FETCH_USER_SAVED_BUILDINGS_TEMPLATES,
  data,
});

export const setPlaces = data => ({
  type: actionTypes.FETCH_PLACES,
  data,
});

/**
 * Set map filters form data.
 *
 * @param mapFormData
 * @returns {{type: string, data: *}}
 */
export const setMapFormData = mapFormData => ({
  type: actionTypes.SET_MAP_FORM_DATA,
  mapFormData,
});

/**
 * Submit action of map filters search.
 *
 * @param data
 * @returns {{type: string, data: *}}
 */
export const submitMapSearch = (data, updateParam = 1) => ({
  type: actionTypes.SUBMIT_MAP_SEARCH,
  data,
  updateParam,
});

/**
 * Update action of map filters search.
 *
 * @param mapSearchResults
 *
 * @returns {{type: string, mapSearchResults: *}}
 */
export const updateMapSearchResults = mapSearchResults => ({
  type: actionTypes.UPDATE_MAP_SEARCH_RESULTS,
  mapSearchResults,
});

/**
 * Update action of map filters search.
 *
 * @returns {{type: string, mapSearchResults: *}}
 */
export const resetMapSearchResults = (saveProperty = false) => ({
  type: actionTypes.RESET_MAP_SEARCH_RESULTS,
  saveProperty,
});

/**
 * Update list results.
 *
 * @returns {{type: string}}
 */
export const updateListResults = () => ({
  type: actionTypes.UPDATE_LIST_RESULTS,
});

/**
 * Update facets results.
 *
 * @returns {{type: string}}
 */
export const updateFacetsResults = data => ({
  type: actionTypes.UPDATE_FACETS,
  data,
});

export const saveUserSavedFiltersTemplates = (name = null, templates = null, callback = null) => {
  const payload = {
    urlPrefix: `${BASE_URL_TYPE.PROPZONE}/saved-filters-templates/`,
    actionType: actionTypes.FETCH_USER_SAVED_FILTERS_TEMPLATES,
    statePath: 'map.mapFormData.formData',
    dataKey: 'filters',
  };
  return saveUserSavedTemplates(name, templates, callback, payload);
};

export const setCurrentFiltersTemplate = name => ({
  type: actionTypes.CURRENT_FILTERS_TEMPLATE,
  name,
});

export const setUserSavedFiltersTemplates = data => ({
  type: actionTypes.FETCH_USER_SAVED_FILTERS_TEMPLATES,
  data,
});

/**
 * Get property lists(folders) data.
 *
 * @param {*} data
 *
 * @returns {{type: string, data: object}}
 */
export const setPropertyLists = data => ({
  type: actionTypes.SET_PROPERTY_LISTS,
  data,
});

/**
 * Set selected property rows.
 *
 * @param {*} data
 *
 * @returns {{type: string, data: object}}
 */
export const setSelectedPropertyRows = data => ({
  type: actionTypes.SET_SELECTED_PROPERTY_ROWS,
  data,
});

/**
 * Get transit types facets.
 *
 * @returns {{type: string}}
 */
export const getTransitTypes = () => ({
  type: actionTypes.GET_TRANSIT_TYPES,
});

/**
 * Get POI's categories facets.
 *
 * @param {*} filters
 *
 * @returns {{type: string}}
 */
export const getPoiCategories = filters => ({
  type: actionTypes.GET_POI_CATEGORIES,
  filters,
});

/**
 * Get Jurisdictions categories facets.
 *
 * @param {*} data
 *
 * @returns {{type: string}}
 */
export const getJurisdictions = data => ({
  type: actionTypes.GET_JURISDICTIONS,
  data,
});

/**
 * Set opened panel property state.
 *
 * @param {*} state
 *
 * @returns {{type: int}}
 */
export const setOpenedPropertyState = state => ({
  type: actionTypes.OPENED_PROPERTY_STATE,
  state,
});

/**
 * Set recent properties.
 *
 * @param {*} object
 *
 * @returns {{type: int}}
 */
export const setRecentProperties = (data, initial = false) => ({
  type: actionTypes.SET_RECENT_PROPERTIES,
  data,
  initial,
});

/**
 * Set followed properties.
 *
 * @param {*} object
 *
 * @returns {{type: int}}
 */
export const setFollowedProperties = data => ({
  type: actionTypes.SET_FOLLOWED_PROPERTIES,
  data,
});

/**
 * Fetch followed properties.
 *
 * @returns {{type: int}}
 */
export const fetchFollowedProperties = () => ({
  type: actionTypes.FETCH_FOLLOWED_PROPERTIES,
});

/**
 * Set properties note datas.
 *
 * @returns {{type: int}}
 */
export const setPropertiesNoteData = data => ({
  type: actionTypes.SET_PROPERTIES_NOTE_DATA,
  data,
});

/**
 * Fetch recent properties addtional data.
 *
 * @returns {{type: string}}
 */
export const fetchRecentAdditions = (items, setLoading = true) => ({
  type: actionTypes.FETCH_RECENT_ADDITIONS,
  items,
  setLoading,
});

/**
 * Set update param flag for map actions.
 */
export const setUpdateParamMap = state => ({
  type: actionTypes.SET_UPDATE_PARAM_MAP,
  state,
});

/**
 * Init clusters.
 */
export const initClusters = () => ({
  type: actionTypes.INIT_CLUSTERS,
});

/**
 * Init clusters.
 */
export const setFiltersLastValueUsed = (name, value) => ({
  type: actionTypes.SET_FILTERS_LAST_VALUE_USE,
  name,
  value,
});

/**
 * Set navigation city.
 */
export const setNavigationPlace = (place, county = '', load = false) => ({
  type: actionTypes.SET_NAVIGATION_PLACE,
  place,
  county,
  load,
});

/**
 * Set navigation property.
 */
export const setNavigationProperty = (property, county = '', load = false) => ({
  type: actionTypes.SET_NAVIGATION_PROPERTY,
  property,
  county,
  load,
});

/**
 * Set navigation state.
 */
export const setNavigationState = (state, stateObject = '') => ({
  type: actionTypes.SET_NAVIGATION_STATE,
  state,
  stateObject,
});

/**
 * Set navigation state.
 */
export const setNavigationCounty = county => ({
  type: actionTypes.SET_NAVIGATION_COUNTY,
  county,
});

/**
 * Set navigation state.
 */
export const toggleZoningLayers = show => ({
  type: actionTypes.TOGGLE_ZONING_LAYERS,
  show,
});

/**
 * Set short URL mode flag.
 * True while the current pathname is /zoning-detail/… and has not yet been swapped.
 */
export const setShortUrlMode = value => ({
  type: actionTypes.SET_SHORT_URL_MODE,
  value,
});
